import {
  eInternalTransferCategory,
  legacyInternalTransferCategories,
} from '../../../types/accounting/response/eInternalTransferCategory';
import { hasAmericanDigitalUnderwriter } from '../hasAmericanDigitalUnderwriter';
import { IParty } from '../../../ui-toolkit/orders/interfaces/IParty';

export const getFilteredLegacyInternalTransferCategories = (parties: IParty[]): eInternalTransferCategory[] => {
  if (hasAmericanDigitalUnderwriter(parties)) {
    return legacyInternalTransferCategories.filter((category) => category !== eInternalTransferCategory.remittance);
  }
  return legacyInternalTransferCategories;
};
